import React from 'react';
import { AnchorButton } from '../Button';
import colors from 'src/style/colors';
import { Description } from 'src/components/DescriptionBlock';
import { mediaQueries } from 'src/style/breakpoints';

const TrainingCard = ({ training, index }) => {
  return (
    <div
      index={index}
      css={{
        backgroundColor: colors.white,
        borderRadius: 10,
        padding: 38,
        flex: 1,
        maxWidth: 800,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        boxShadow: 'rgba(0, 0, 0, 0.04) 1px 2px 15px',
        [mediaQueries.phoneOnly]: {
          padding: 32,
          marginBottom: 8,
        },
        [mediaQueries.tabletPortraitUp]: {
          padding: 32,
          marginBottom: 8,
        },
        [mediaQueries.tabletLandscapeUp]: {
          '&:not(:last-child)': { marginRight: 16 },
        },
      }}
    >
      <Description title={training.name} subtitle={training.duration} text={training.description} />
      <AnchorButton isSmall secondary to={training.slug} css={{ width: 135 }} >
        Plus d'info
      </AnchorButton>
    </div>
  );
};
export default TrainingCard;
